import { lazy } from 'react';
var SYS_PAGE = ['1', '2', '4', '5', '6'];
var SYS_ROUTES = SYS_PAGE.map(function (obj) { return ({
    path: "/SYS00/SYS0000" + obj,
    component: lazy(function () { return import("view/Project/SYS/SYS0000" + obj); }),
}); });
export default SYS_ROUTES;
